var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 262,
    viewBox: "0 0 262 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_183_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 177.521C159.167 177.521 182 154.795 182 126.76C182 98.7262 159.167 76 131 76C102.833 76 80 98.7262 80 126.76C80 154.795 102.833 177.521 131 177.521Z",
    fill: "#153049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.001 169.38C154.671 169.38 173.86 150.191 173.86 126.521C173.86 102.851 154.671 83.6621 131.001 83.6621C107.33 83.6621 88.1416 102.851 88.1416 126.521C88.1416 150.191 107.33 169.38 131.001 169.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.154 115.746C176.252 166.268 117.111 175.845 102.745 152.62C100.926 150.386 97.4965 147.381 99.1538 149.986C100.811 152.591 96.7694 150.279 95.562 147.831C94.644 145.97 95.3719 142.523 95.562 141.127C95.5739 143.596 95.8277 144.858 97.2383 146.634C97.8381 147.498 99.6887 148.158 102.745 145.915C106.295 143.312 109.21 136.099 113.759 128.197C117.399 121.876 120.863 121.573 122.14 122.211C128.844 123.552 123.337 131.549 130.999 135.38C133.366 136.09 137.137 132.588 140.462 129.501L140.576 129.394C143.928 125.803 145.934 121.547 151.59 115.746C157.098 110.098 158.826 111.169 162.844 109.521C165.814 108.302 168.031 108.404 168.59 108.803C168.271 108.803 166.033 109.521 167.154 115.746Z",
    fill: "#28A9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.644 117.662C163.537 116.895 160.137 117.343 158.7 117.662C157.264 116.464 165.644 114.07 165.644 113.831C165.644 113.591 164.686 111.915 164.208 111.197C163.824 110.622 166.921 110.479 168.517 110.479C168.118 111.835 167.32 114.836 167.32 115.986C167.32 117.135 166.202 117.582 165.644 117.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.774 101.859C120.272 68.3381 89.0391 107.208 94.0672 132.109L94.6048 134.423L95.3232 137.057C95.3232 135.524 97.9357 131.15 98.973 129.793C96.4831 137.647 97.9357 139.929 98.973 140.089C103.953 135.875 107.832 118.061 118.846 114.709C129.86 111.357 125.072 130.512 128.903 127.638C132.734 124.765 144.62 101.421 161.168 105.211C161.647 105.211 160.21 103.11 158.774 101.859Z",
    fill: "#173653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 137.056C131.767 137.095 131.819 137.131 131.873 137.164C133.433 137.915 140.168 133.51 142.013 131.664C143.298 130.379 147.361 125.803 149.675 124.126C158.056 118.62 161.887 120.774 161.408 123.408C162.174 126.665 157.098 127 153.507 128.676C149.967 130.328 135.503 139.418 131.873 137.164C131.813 137.136 131.762 137.1 131.718 137.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.456 154.025L126.866 152.28L122.327 148.685L126.866 145.089L125.456 143.344L119.817 147.812C119.685 147.917 119.578 148.05 119.505 148.201C119.432 148.352 119.394 148.517 119.394 148.685C119.394 148.852 119.432 149.018 119.505 149.169C119.578 149.32 119.685 149.452 119.817 149.557L125.456 154.025ZM135.889 143.344L134.479 145.089L139.017 148.685L134.479 152.28L135.889 154.025L141.528 149.557C141.66 149.452 141.767 149.32 141.84 149.169C141.913 149.018 141.951 148.852 141.951 148.685C141.951 148.517 141.913 148.352 141.84 148.201C141.767 148.05 141.66 147.917 141.528 147.812L135.889 143.344Z",
    fill: "#363543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.965 140.555L129.453 160.662L127.25 160.177L131.762 140.07L133.965 140.555Z",
    fill: "#363543"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_183_272",
    x: 0,
    y: 0,
    width: 262,
    height: 261.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.662745 0 0 0 0 0.886275 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_272",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dfb17e6fadf7d57244a6c2437d0cb170.svg";
export { ForwardRef as ReactComponent };